import React, { useState } from 'react'
import { useTestContext } from '../TestContext'
import Button from 'app/components/Button'
import CustomModal from 'app/components/CustomModal'

const MarkAsNotRequiredModal: React.FC = () => {
  const {
    isMarkAsNotRequiredModalOpen,
    isMarkingAsNotRequired,
    handleCloseMarkAsNotRequiredModal,
    handleConfirmMarkAsNotRequired,
  } = useTestContext()

  const [localMarkAsNotRequiredReason, setLocalMarkAsNotRequiredReason] = useState('')

  const handleMarkAsNotRequiredSubmit = async () => {
    await handleConfirmMarkAsNotRequired(localMarkAsNotRequiredReason)
    setLocalMarkAsNotRequiredReason('')
  }

  const handleClose = () => {
    handleCloseMarkAsNotRequiredModal()
    setLocalMarkAsNotRequiredReason('')
  }

  return (
    <CustomModal
      show={isMarkAsNotRequiredModalOpen}
      onClose={handleClose}
    >
      <p className='fw-bold mb-1 fs-2 text-gray-900'>Mark as Not Required</p>
      <p className='text-gray-900 fs-7' style={{textAlign: 'left', marginBottom: '20px'}}>
        Reason for marking as not required will be posted as a note on this test for this evidence.
      </p>
      <div className='mb-4'>
        <textarea
          className='form-control'
          placeholder='Reason...'
          value={localMarkAsNotRequiredReason}
          onChange={(e) => setLocalMarkAsNotRequiredReason(e.target.value)}
          rows={4}
        />
      </div>
      <div className='d-flex justify-content-end gap-3'>
        <Button btnType='secondary' onClick={handleClose}>
          Cancel
        </Button>
        <Button
          btnType='default'
          onClick={handleMarkAsNotRequiredSubmit}
          disabled={isMarkingAsNotRequired || !localMarkAsNotRequiredReason.trim()}
        >
          {isMarkingAsNotRequired ? (
            <>
              Marking...
              <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
            </>
          ) : (
            'Mark as Not Required'
          )}
        </Button>
      </div>
    </CustomModal>
  )
}

export default MarkAsNotRequiredModal 